import Vue, { ComponentOptions } from 'vue'
const template = require('./modal.html') as string;

export default {
  props: ['css'],
  template: template
} as ComponentOptions<Vue>


// WEBPACK FOOTER //
// ./static-content/public/javascripts/components/modal.ts